module.exports = __webpack_public_path__ + "static/media/giant_paper_straw2.480d67ee.png";